export const FirebaseConfig = {
	"projectId": "gosafe-8da5a",
	"appId": "1:1002887776253:web:e46e81b9d8b4403f0d3b94",
	"databaseURL": "https://gosafe-8da5a-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "gosafe-8da5a.firebasestorage.app",
	"apiKey": "AIzaSyCQNFqYHtzy-ETkxM9mVDgZAVfxJ2_WpdQ",
	"authDomain": "gosafe-8da5a.firebaseapp.com",
	"messagingSenderId": "1002887776253",
	"measurementId": "G-QECZM0F0LT",
	"projectNumber": "1002887776253",
	"version": "2"
};